import React, { FC } from 'react';
import { Button } from 'wix-style-react';
import { marketplaceHeaderClientGenericClick } from '@wix/bi-logger-marketplace/v2';
import { dataHooks, logoutUrl } from '../../utils/constants';
import { useBi } from '../../../Hooks/useBi';

interface LogoutBtnProps {
  btnLogoutLabel: string;
  pageName: string;
}

const LogoutBtn: FC<LogoutBtnProps> = ({ btnLogoutLabel, pageName }) => {
  const logger = useBi();
  return (
    <Button
      dataHook={dataHooks.logoutBtn}
      size="small"
      priority="secondary"
      skin="dark"
      onClick={() => {
        logger.report(
          marketplaceHeaderClientGenericClick({
            clickType: 'click in profile drop down menu',
            click_data: 'log out',
            pageName,
          }),
        );
        window.open(logoutUrl(window.location.href), '_self');
      }}
      className="btnDarkSecondary"
    >
      {btnLogoutLabel}
    </Button>
  );
};

export default LogoutBtn;
